/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './accounting-bank-account.reducer';

export const AccountingBankAccountDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const accountingBankAccountEntity = useAppSelector(state => state.accountingBankAccount.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="accountingBankAccountDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.accountingBankAccount.detail.title">AccountingBankAccount</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.id">Id</Translate>
            </span>
          </dt>
          <dd>{accountingBankAccountEntity.id}</dd>
          <dt>
            <span id="accountHolderName">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.accountHolderName">Account Holder Name</Translate>
            </span>
          </dt>
          <dd>{accountingBankAccountEntity.accountHolderName}</dd>
          <dt>
            <span id="accountNo">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.accountNo">Account No</Translate>
            </span>
          </dt>
          <dd>{accountingBankAccountEntity.accountNo}</dd>
          <dt>
            <span id="ifscCode">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.ifscCode">Ifsc Code</Translate>
            </span>
          </dt>
          <dd>{accountingBankAccountEntity.ifscCode}</dd>
          <dt>
            <span id="allowedCredit">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.allowedCredit">Allowed Credit</Translate>
            </span>
          </dt>
          <dd>{accountingBankAccountEntity.allowedCredit}</dd>
          <dt>
            <span id="maxCreditLimit">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.maxCreditLimit">Max Credit Limit</Translate>
            </span>
          </dt>
          <dd>{accountingBankAccountEntity.maxCreditLimit}</dd>
          <dt>
            <span id="standardCreditLimit">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.standardCreditLimit">Standard Credit Limit</Translate>
            </span>
          </dt>
          <dd>{accountingBankAccountEntity.standardCreditLimit}</dd>
          <dt>
            <span id="inactive">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.inactive">Inactive</Translate>
            </span>
          </dt>
          <dd>{accountingBankAccountEntity.inactive ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.active">Active</Translate>
            </span>
          </dt>
          <dd>{accountingBankAccountEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{accountingBankAccountEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{accountingBankAccountEntity.timestampEntry}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{accountingBankAccountEntity.lastUpdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{accountingBankAccountEntity.cursor}</dd>
          <dt>
            <span id="entityId">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.entityId">Entity Id</Translate>
            </span>
          </dt>
          <dd>{accountingBankAccountEntity.entityId}</dd>
          <dt>
            <span id="openingBalance">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.openingBalance">Opening Balance</Translate>
            </span>
            <UncontrolledTooltip target="openingBalance">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.help.openingBalance" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingBankAccountEntity.openingBalance}</dd>
          <dt>
            <span id="overDraft">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.overDraft">Over Draft</Translate>
            </span>
            <UncontrolledTooltip target="overDraft">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.help.overDraft" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingBankAccountEntity.overDraft ? 'true' : 'false'}</dd>
          <dt>
            <span id="closingBalance">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.closingBalance">Closing Balance</Translate>
            </span>
            <UncontrolledTooltip target="closingBalance">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.help.closingBalance" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingBankAccountEntity.closingBalance}</dd>
          <dt>
            <span id="createdById">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.createdById">Created By Id</Translate>
            </span>
            <UncontrolledTooltip target="createdById">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.help.createdById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingBankAccountEntity.createdById}</dd>
          <dt>
            <span id="createdByType">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.createdByType">Created By Type</Translate>
            </span>
            <UncontrolledTooltip target="createdByType">
              <Translate contentKey="tinyMedicRestApp.accountingBankAccount.help.createdByType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingBankAccountEntity.createdByType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingBankAccount.institution">Institution</Translate>
          </dt>
          <dd>{accountingBankAccountEntity.institution ? accountingBankAccountEntity.institution.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingBankAccount.baseCurrency">Base Currency</Translate>
          </dt>
          <dd>{accountingBankAccountEntity.baseCurrency ? accountingBankAccountEntity.baseCurrency.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingBankAccount.accountType">Account Type</Translate>
          </dt>
          <dd>{accountingBankAccountEntity.accountType ? accountingBankAccountEntity.accountType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingBankAccount.entityType">Entity Type</Translate>
          </dt>
          <dd>{accountingBankAccountEntity.entityType ? accountingBankAccountEntity.entityType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingBankAccount.tax">Tax</Translate>
          </dt>
          <dd>
            {accountingBankAccountEntity.taxes
              ? accountingBankAccountEntity.taxes.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {accountingBankAccountEntity.taxes && i === accountingBankAccountEntity.taxes.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingBankAccount.otherCurrency">Other Currency</Translate>
          </dt>
          <dd>
            {accountingBankAccountEntity.otherCurrencies
              ? accountingBankAccountEntity.otherCurrencies.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {accountingBankAccountEntity.otherCurrencies && i === accountingBankAccountEntity.otherCurrencies.length - 1
                      ? ''
                      : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/accounting-bank-account" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/accounting-bank-account/${accountingBankAccountEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AccountingBankAccountDetail;
